import '../../sass/main.scss'

// Images
import '../../images/video_min.jpg'
import '../../images/fidelidade/academia-moinhos-fitness.jpg'
import '../../images/fidelidade/cartao_fidelidade.png'
import '../../images/fidelidade/laboratorio-marques-dalmeida.jpg'
import '../../images/fidelidade/logo-expert.jpg'
import '../../images/fidelidade/logo-multiplus.jpg'
import '../../images/fidelidade/logo-opus.jpg'
import '../../images/fidelidade/logo-santa-casa-porto-alegre.jpg'
import '../../images/fidelidade/logos-fleury.jpg'
import '../../images/fidelidade/menos-sacolas.jpg'
import '../../images/fidelidade/quick-massage.jpg'
import '../../images/fidelidade/revista-ofertas.jpg'
import '../../images/fidelidade/logo-alvaro-frischmann.jpg'
import '../../images/fidelidade/serdil-weinmann.png'
import '../../images/marcador_motoboy.png'
import '../../images/banner-convenios.jpg'
import '../../images/faixa-app-background.png'
import '../../images/icon-app.png'
import '../../images/icon-download.png'
import '../../images/icons/logo-assinatura-azul.png'
import '../../images/logo_android.png'
import '../../images/logo_appstore.png'
import '../../images/ebit2.jpg'
import '../../images/icons/tag.svg'
import '../../images/exclamacao.png'
import '../../images/embalagens.png'

// Polyfills
import '../polyfill/polyfill'

// Components
import { Navigation } from 'components/nav'
import { SearchComponent } from 'components/search/search.component'
import { HideHeader } from 'components/hideHeader'
import { NewsletterComponent } from 'components/newsletter/newsletter.component'
import { LazyLoadImg } from 'components/lazyLoadImg'
import { VitrineComponent } from 'components/vitrine/vitrine.component'
import { AdicionarCestaComponent } from 'components/cesta/adicionar/adicionarCesta.component'
import { SlideShowComponent } from 'components/slideshow/slideshow.component'
import { BlackfridayComponent } from 'components/blackfriday/blackfriday.component.js'
import { ModalAvisemeComponent } from 'components/modal/modal-aviseme/modal-aviseme.component'
import { ModalSoliciteaquiComponent } from 'components/modal/modal-soliciteaqui/modal-soliciteaqui.component'
import { ModalVendaRestritaComponent } from 'components/modal/modal-vendarestrita/modal-vendarestrita.component'
import { ModalNewsLetterComponent } from 'components/modal/modal-newsletter/modal-newsletter.component'
import { ModalPbmComponent } from 'components/modal/modal-pbm/modal-pbm.component'
import { ModalBemPanvelComponent } from 'components/modal/modal-bem-panvel/modal-bem-panvel.component'
import { ModalVariacaoProdutoComponent } from 'components/modal/modal-variacao-produto/modal-variacao-produto.component'
import { FilterComponent } from 'components/filters'
import { ShowHidePasswordComponent } from 'components/form/showHidePassword.component'
import { ModalWindow } from 'components/modal/modal-window/modal-window'
import { ErrorComponent } from 'components/error/error.component'
import { ToggleComponent } from 'components/toggle/toggle.component'
import { CepNavigationComponent } from 'components/cep-navigation/cep-navigation.component'
import { TooltipComponent } from 'components/tooltip/tooltip.component'
import { PedidoAbertoComponent } from 'components/pedido-aberto.component'
import { SliderComponent } from 'components/slider/slider.component'
import { SliderV2Component } from 'components/slider/slider-v2.component'
import { ChatComponent } from 'components/chat.component.js'
import { CardComponent } from 'components/card/card.component'
import { PbmLoginComponent } from 'components/modal/modal-pbm/pbm-login/pbm-login.component'
import { PhoneMask } from 'components/phoneMask'
import { CookiesComponent } from 'components/cookies/cookies.component'
import { DetalhePedidoComponent } from '../pages/minha-conta/pedido/detalhe-pedido.component'
import { ListagemPedidoComponent } from '../pages/minha-conta/pedido/listagem-pedido.component'

const nav = new Navigation()
const searchComponent = new SearchComponent()
const hideHeader = new HideHeader()
const newsLetter = new NewsletterComponent()
const lazyLoad = new LazyLoadImg()
const vitrine = new VitrineComponent()
const adicionarItemCesta = new AdicionarCestaComponent()
const slideShowComponent = new SlideShowComponent()
const blackfridayComponent = new BlackfridayComponent()
const modalAvisemeComponent = new ModalAvisemeComponent()
const modalSoliciteaquiComponent = new ModalSoliciteaquiComponent()
const modalVendaRestritaComponent = new ModalVendaRestritaComponent()
const modalNewsLetterComponent = new ModalNewsLetterComponent()
const modalPbmComponent = new ModalPbmComponent()
const modalBemPanvelComponent = new ModalBemPanvelComponent()
const modalVariacaoProdutoComponent = new ModalVariacaoProdutoComponent()
const pbmLoginComponent = new PbmLoginComponent()
const filterComponent = new FilterComponent()
const showHidePasswordComponent = new ShowHidePasswordComponent()
const modalWindow = new ModalWindow();
const errorComponent = new ErrorComponent();
const toggleComponent = new ToggleComponent();
const cepNavigationComponent = new CepNavigationComponent();
const tooltipComponent = new TooltipComponent();
const pedidoAbertoComponent = new PedidoAbertoComponent();
const sliderComponentBrands = new SliderComponent('#slider-brands_content', {320: {items: 1.3},500: {items: 5.5}});
const sliderComponentCategories = new SliderComponent('#slider-categories_content', {320: {items: 2.2},500: {items: 5.5}});
const sliderComponentBanners = new SliderComponent('#slider-banners-mobile_content', {320: {items: 1.1},500: {items: 3.5}});
const SliderV2ComponentVariationProducts = new SliderV2Component('#modal-variation-products');
const sliderComponentParceiros = new SliderComponent('#slider-parceiros_content', {320: {items: 1},600: {items: 2},800: {items: 3},1200: {items: 4},1600: {items: 5},1900: {items: 6}});
const chatComponent = new ChatComponent();
const cardComponent = new CardComponent();
const phoneMask = new PhoneMask();
const cookiesComponent = new CookiesComponent();
const detalhePedidoComponent = new DetalhePedidoComponent();
const listagemPedidoComponent = new ListagemPedidoComponent();


// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/entries/main.js